import React, {Component} from 'react';
import AuthenticatedTemplate from "../../Components/Templates/Authenticated/index";
import { Card, Grid, StatsCard } from 'tabler-react';
import {
    AreaChart, Area, ComposedChart, XAxis, Tooltip, ResponsiveContainer, Legend, BarChart, Bar, Line
} from 'recharts';
import './index.sass';

const accessData = [
    {
        name: 'Seg', views: 2400,
    },
    {
        name: 'Ter', views: 2210,
    },
    {
        name: 'Qua', views: 2290,
    },
    {
        name: 'Qui', views: 2000,
    },
    {
        name: 'Sex', views: 2181,
    },
    {
        name: 'Sáb', views: 2500,
    },
    {
        name: 'Dom', views: 2100,
    },
];

const hoursData = [
    {
        "name": "00",
        "views": 600
    },
    {
        "name": "01",
        "views": 350
    },
    {
        "name": "02",
        "views": 230
    },
    {
        "name": "03",
        "views": 100
    },
    {
        "name": "04",
        "views": 30
    },
    {
        "name": "05",
        "views": 3
    },
    {
        "name": "06",
        "views": 2
    },
    {
        "name": "07",
        "views": 10
    },
    {
        "name": "08",
        "views": 600
    },
    {
        "name": "09",
        "views": 600
    },
    {
        "name": "10",
        "views": 750
    },
    {
        "name": "11",
        "views": 800
    },
    {
        "name": "12",
        "views": 200
    },
    {
        "name": "13",
        "views": 50
    },
    {
        "name": "14",
        "views": 180
    },
    {
        "name": "15",
        "views": 400
    },
    {
        "name": "16",
        "views": 500
    },
    {
        "name": "17",
        "views": 550
    },
    {
        "name": "18",
        "views": 600
    },
    {
        "name": "19",
        "views": 730
    },
    {
        "name": "20",
        "views": 1000
    },
    {
        "name": "21",
        "views": 1300
    },
    {
        "name": "22",
        "views": 1700
    },
    {
        "name": "23",
        "views": 1200
    }
];



class Stats extends Component {

    render() {

        const chart = (color="#8884d8") => (
            <ResponsiveContainer width="100%" height={90}>
                <AreaChart
                    data={accessData}
                    margin={{
                        top: 10, right: 0, left: 0, bottom: 0
                    }}>
                    <XAxis dataKey="name" hide />
                    <Tooltip />
                    <Area type="monotone" dataKey="views" stroke={color} fill={color} />
                </AreaChart>
            </ResponsiveContainer>
        );

        return (
            <AuthenticatedTemplate title="Estatísticas" options={
                <p className="text-right small text-muted pr-3 pt-3">Informações coletadas entre os dias .</p>
            }>
                <h3>Acessos ao perfil</h3>

                <Grid.Row className="charts">
                    <Grid.Col width="6">
                        <StatsCard total={665} layout={2} movement={9} chart={chart()} label="Acessos ao perfil" />
                    </Grid.Col>

                    <Grid.Col width="6">
                        <StatsCard total={50} layout={2} movement={10} chart={chart()} label="Acessos de produtores" />
                    </Grid.Col>

                    <Grid.Col width="6">
                        <StatsCard total={150} layout={2} movement={-8} chart={chart()} label="Acessos de artistas" />
                    </Grid.Col>

                    <Grid.Col width="6">
                        <StatsCard total={465} layout={2} movement={2} chart={chart()} label="Acessos da web" />
                    </Grid.Col>

                    <Grid.Col width="12">
                        <Card>
                            <Card.Body>
                                <p className="text-center text-muted">Acessos distribuídos por horas do dia</p>
                                <ResponsiveContainer width="100%" height={200}>
                                    <BarChart data={hoursData}>
                                        <XAxis dataKey="name" />
                                        <Tooltip />
                                        <Legend />
                                        <Bar dataKey="views" fill="#8884d8" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </Card.Body>
                        </Card>
                    </Grid.Col>
                </Grid.Row>

                <h3 className="mt-4">Aparições em pesquisas</h3>

                <Grid.Row className="charts">
                    <Grid.Col width="6">
                        <StatsCard total={665} layout={2} movement={9} chart={chart('#82ca9d')} label="Pesquisas" />
                    </Grid.Col>

                    <Grid.Col width="6">
                        <StatsCard total={50} layout={2} movement={10} chart={chart('#82ca9d')} label="Pesquisas por produtores" />
                    </Grid.Col>

                    <Grid.Col width="6">
                        <StatsCard total={150} layout={2} movement={-8} chart={chart('#82ca9d')} label="Pesquisas artistas" />
                    </Grid.Col>

                    <Grid.Col width="6">
                        <StatsCard total={465} layout={2} movement={2} chart={chart('#82ca9d')} label="Pesquisas da web" />
                    </Grid.Col>
                </Grid.Row>
            </AuthenticatedTemplate>
        );
    }
}

export default Stats;